<template>
    <section class="edge-container media-gallery__container">
        <router-view />
    </section>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
    name: "media-gallery",
})
</script>


